// extracted by mini-css-extract-plugin
export default {"page":"Oi-z","cartModal":"Pi-z","checkout":"Qi-z","placeholder":"Ri-z","account":"Si-z"};